import axios from 'axios'
import urls from './urls'
import querystring from 'querystring'

const getListShipment = async function (filters, page) {
  try {
    let data = {
      page: page,
      size: 10,
      status: filters.status,
      selfOrder: 1,
      // sort: `pickupDate;DESC,id;ASC`,
      sort: `deliveryDate;DESC`,
    }
    console.log('file: order.js ~ line 14 ~ getListShipment ~ data', data)

    if (filters.dateFrom) { data.dateFrom = filters.dateFrom }
    if (filters.dateTo) { data.dateTo = filters.dateTo }
    if (filters.shipmentNo) { data.shipmentNo = filters.shipmentNo }

    const res = await axios.get(urls.getListShipment + '?' + querystring.stringify(data))
    return Promise.resolve(res.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

const getShipment = async function (orderId) {
  try {
    const res = await axios.get(urls.getShipment + '/' + orderId)
    return Promise.resolve(res.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

const getAvailableVehicle = async function () {
  try {
    let filters = {
      page: 0,
      size: 10,
    }
    const res = await axios.get(urls.getVehicle + '?' + querystring.stringify(filters))
    return Promise.resolve(res.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

const getInformation = async function (type) {
  try {
    let filters = {
      page: 0,
      size: 10,
      type: type
    }
    const res = await axios.get(urls.getInfo + '?' + querystring.stringify(filters))
    return Promise.resolve(res.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

const getCategory = async function () {
  try {
    let filters = {
      page: 0,
      size: 1000,
    }
    const res = await axios.get(urls.getCategory + '?' + querystring.stringify(filters))
    return Promise.resolve(res.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

const getUnAssignShipment = async function (originId, destinationId, deliveryDate, transportTypeId, reffShipmentId) {
  try {
    let data = {
      originId,
      destinationId,
      deliveryDate,
      transportTypeId
    }
    if (reffShipmentId) { data.reffShipmentId = reffShipmentId }
    const res = await axios.get(urls.getUnAssignShipment + '?' + querystring.stringify(data))
    return Promise.resolve(res.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

const getSubCategory = async function (idCategory) {
  try {
    let filters = {
      page: 0,
      size: 1000,
    }
    const res = await axios.get(urls.getSubCategory(idCategory) + '?' + querystring.stringify(filters))
    return Promise.resolve(res.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

const getOrderSummary = async function () {
  try {
    const res = await axios.get(urls.getOrderSummary)
    return Promise.resolve(res.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

const getLocationOrigin = async function (name) {
  try {
    let filters = {
      page: 0,
      size: 20,
    }
    if (name) filters.name = name
    const res = await axios.get(urls.getLocationOrigin + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const getLocationDestination = async function (name) {
  try {
    let filters = {
      page: 0,
      size: 20,
    }
    if (name) filters.name = name
    const res = await axios.get(urls.getLocationDestination + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const getVehicleById = async function (vehicleId) {
  try {
    const res = await axios.get(urls.getVehicleById + '/' + vehicleId)
    return Promise.resolve(res.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

const postOrder = async function (listOrder) {
  try {
    console.log('List  Order', listOrder)
    const res = await axios.post(urls.createShipment, listOrder)
    return Promise.resolve(res.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * create a continue order
 * @param {Object} order order detail
 *  @param {Object} order.transportTypeId transportTypeId
 *  @param {Object} order.originId originId
 *  @param {Object} order.destinationId destinationId
 *  @param {Object} order.categoryId categoryId
 *  @param {Object} order.subCategoryId subCategoryId
 *  @param {Object} order.pickupDate pickupDate
 *  @param {Object} order.transportTypeId transportTypeId
 *  @param {Object} order.orderId orderId
 *  @param {Object} order.reffShipperMergeShipmentId orderId
 *  @param {Object} order.isShipperFullLoad orderId
 *  @param {Object} [order.originNote] originNote
 *  @param {Object} [order.originPicName] originPicName
 *  @param {Object} [order.originPicPhone] originPicPhone
 *  @param {Object} [order.destinationNote] destinationNote
 *  @param {Object} [order.destinationPicName] destinationPicName
 *  @param {Object} [order.destinationPicPhone] destinationPicPhone
 *  @param {Object} [order.deliveryNote] deliveryNote
 *  @param {Object} [order.pickupNote] pickupNote
 */
const postContinueOrder = async function ({
  transportTypeId,
  originId,
  destinationId,
  categoryId,
  subCategoryId,
  pickupDate,
  orderId,
  originNote = null,
  originPicName = null,
  originPicPhone = null,
  destinationNote = null,
  destinationPicName = null,
  destinationPicPhone = null,
  deliveryNote = null,
  pickupNote = null,
  reffShipperMergeShipmentId,
  isShipperFullLoad
}) {
  try {
    let order = {
      transportTypeId,
      originId,
      destinationId,
      categoryId,
      subCategoryId,
      pickupDate,
      reffShipmentId: orderId,
      originNote,
      originPicName,
      originPicPhone,
      destinationNote,
      destinationPicName,
      destinationPicPhone,
      deliveryNote,
      pickupNote,
      reffShipperMergeShipmentId,
      isShipperFullLoad
    }
    console.log('TCL: order', order)
    const res = await axios.post(urls.createContinueShipment, order)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const getStatusHistory = async function (idShipment) {
  try {
    const res = await axios.get(urls.getStatusHistory(idShipment))
    return Promise.resolve(res.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

const getDocument = async function (idShipment, type) {
  try {
    let filters = {
      page: 0,
      size: 20,
    }
    const res = await axios.get(urls.getDocument(idShipment, type) + '?' + querystring.stringify(filters))
    return Promise.resolve(res.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

const getPodDocument = async function (shipmentId) {
  try {
    let filters = {
      shipmentId
    }
    const res = await axios.get(urls.podDocument + '?' + querystring.stringify(filters))
    return Promise.resolve(res.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

const cancelShipment = async function (idShipment, reason) {
  try {
    var param = {
      shipmentId: idShipment,
      reason: reason,
    }
    const res = await axios.post(urls.cancelShipment, param)
    return Promise.resolve(res.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

const shipperConfirm = async function (idShipment) {
  try {
    var param = {
      shipmentId: idShipment
    }
    const res = await axios.post(urls.shipperConfirm, param)
    return Promise.resolve(res.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

const postRating = async function (idShipment, rating) {
  try {
    var param = {
      shipmentId: idShipment,
      rating: rating,
    }
    const res = await axios.post(urls.postRating, param)
    return Promise.resolve(res.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

const getDamageShipment = async function (shipmentId) {
  try {
    let filters = {
      shipmentId
    }
    const res = await axios.get(urls.getDamageShipment + '?' + querystring.stringify(filters))
    return Promise.resolve(res.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  getListShipment,
  getShipment,
  getAvailableVehicle,
  getInformation,
  getCategory,
  getSubCategory,
  postOrder,
  getLocationOrigin,
  getLocationDestination,
  getVehicleById,
  getStatusHistory,
  getDocument,
  cancelShipment,
  postRating,
  postContinueOrder,
  getPodDocument,
  getUnAssignShipment,
  shipperConfirm,
  getOrderSummary,
  getDamageShipment
}
